import React, { useState } from "react";
import  {Navigate, useNavigate } from 'react-router-dom';


import { Sidebar } from './Sidebar';
import MapBox from './MapBox';

import AlertCard from "./Alert";

export default function Tech() {
  const [session] = useState(localStorage.getItem("session") || null);
  const [rank] = useState(localStorage.getItem("rank") || 0);
  const [authenticated] = useState(localStorage.getItem("authenticated") || false);
  const navigate = useNavigate();

  
  var featureCollection = {
    "type": "FeatureCollection",
    features: []
  }
  
  React.useEffect(() => {
    if ((!session) || (rank!=5)) navigate('/')  
  }, []);

  if (authenticated) {
    return (
      
      <div className='h-screen w-screen fixed'>
        
        <div >
        <MapBox features={featureCollection}/>
        </div>

        <Sidebar features={featureCollection}/> 
       
        <AlertCard />
      </div>
      
    );
  }
  else 
  {
    return <Navigate to={"/"} replace />;
  }
  }
  
 
  